import fixed from '@/fixed';

export const prefixOptions = [
  {
    condition: /^Postnord/,
    getClass: () => 'bg-danger',
  },
  {
    condition: /^(Bedriftspakke|Bediftspakke)/,
    getClass: () => 'bg-danger',
  },
  {
    condition: /Henting.*Lyngdal/i,
    getClass: () => 'bg-success',
  },
  {
    condition: /Henting(?!.*Lyngdal)/,
    getClass: () => 'pickup-location',
  },
];
const defaultClass = 'bg-success';

// Mappings to get classes dynamically based on metadata and delivery location
export const metadataMapping = [
  { pattern: /^WORKSHOP$/, getClass: () => 'bg-info' },
  { pattern: /^regos_\d+$/, getClass: () => 'regos-tape' },
  {
    pattern: /^ordre_\d+$/,
    getClass: (delivery) => {
      if (!delivery) return defaultClass;

      const matchingLocation = prefixOptions.find(({ condition }) => condition.test(delivery));
      return matchingLocation ? matchingLocation.getClass() : defaultClass;
    },
  },
  /* === Catch anything that's not found in other matches === */
  { pattern: /.*/, getClass: () => defaultClass },
];

export const stripHtmlTags = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

export const getRowClass = (row) => {
  if (row.notes && !row.noteType) return 'bg-primary';
  if (row.notes && row.noteType === 1) return 'wrong-ean text-white';
  if (row.notes && row.noteType === 2) return 'unavailable-goods text-white';
  if (row.notes && row.noteType === 3) return 'goods-replaced-with text-dark';
  if (row.notes && row.noteType === 4) return 'bg-danger text-muted';

  return '';
};

// "18-V 9 A Box98" / "18-v 9 a box 98" - the box part is optional.
const LOCATION_RE = /^(\d+\s*-\s*[VH])\s+(\d+)\s+([A-Z])(?:\s+BOX\s*(\d+))?$/;
const MAX_BOX = 250;

// Turns a scanned shelf QR / typed location into { rafa, kolona, red, box }.
// Returns { error } when it is not a location that exists in the shelf lists.
export const parseLocation = (value) => {
  const match = String(value || '').trim().toUpperCase().replace(/\s+/g, ' ')
    .match(LOCATION_RE);
  if (!match) return { error: 'Use a location such as "18-V 9 A Box98"' };

  const parsed = {
    rafa: match[1].replace(/\s/g, ''),
    kolona: String(Number(match[2])),
    red: match[3],
    box: match[4] ? `Box${Number(match[4])}` : '',
  };

  const { rafe, kolone, redovi } = fixed.locations;
  const unknown = [
    ['shelf', rafe, parsed.rafa],
    ['number', kolone, parsed.kolona],
    ['letter', redovi, parsed.red],
  ].find(([, options, val]) => !options.some((o) => o.value === val));
  if (unknown) return { error: `Unknown ${unknown[0]}: ${unknown[2]}` };

  const box = Number(match[4]);
  if (match[4] && (box < 1 || box > MAX_BOX)) return { error: `Unknown box: ${parsed.box}` };

  return parsed;
};
